import create from 'zustand';

import {
  getBondOrderDetail,
  getBondOrderList,
} from 'global/Securities/api/bond';
import { BondOrder } from 'global/Securities/types/api/bond';

interface State {
  selected?: BondOrder;
  list: BondOrder[];
  isLoading: boolean;
  isLoadingList: boolean;
}

interface Actions {
  loadOrderDetails(id: string): Promise<void>;
  loadOrderList(): Promise<void>;
  clearSelected(): void;
  clearList(): void;
  clear(): void;
}

type Store = State & Actions;

const initialState: State = {
  selected: undefined,
  list: [],
  isLoading: false,
  isLoadingList: false,
};

export const useBondOrder = create<Store>((set, get) => ({
  ...initialState,

  async loadOrderDetails(id) {
    try {
      set({ isLoading: true });
      const { list } = get();

      // get from the list
      const index = list.findIndex((data) => data.id === id);
      if (index >= 0) {
        set({ selected: list[index], isLoading: false });
        return;
      }

      // if not on the list, then fetch order by id
      const response = await getBondOrderDetail(id);
      const {
        data: { order },
      } = response.data;

      set({ selected: order, isLoading: false });
    } catch (error) {
      set({ isLoading: false });
      Promise.reject(error);
    }
  },

  async loadOrderList() {
    try {
      set({ isLoadingList: true });
      const response = await getBondOrderList();
      const {
        data: { orders },
      } = response.data;

      set({ list: orders, isLoadingList: false });
    } catch (error) {
      set({ isLoadingList: false });
      Promise.reject(error);
    }
  },

  clearSelected() {
    set({ selected: null });
  },

  clearList() {
    set({ list: [] });
  },

  clear() {
    set(initialState);
  },
}));
